import React from 'react'
import { Grid, PageSection } from '@superhi/design'

import Chapter from './components/Chapter'
import { Chapters } from './styles'

export const ID = 'section__library-guide-contents'

type Props = {
  items: Omit<React.ComponentProps<typeof Chapter>, 'number'>[]
}

const GRID_1_CELL_SPAN_1: React.ComponentProps<typeof Grid.Cell>['span'] = {
  small: 'full',
  medium: 'full',
  large: [2, 11],
}

const Contents: React.FC<Props> = ({ items = [] }) => (
  <PageSection
    id={ID}
    title="What's in the guide?"
    decorationName="star"
    decorationPosition="top-right"
  >
    <Grid>
      <Grid.Cell span={GRID_1_CELL_SPAN_1}>
        <Chapters>
          {items.map((item, i) => (
            <Chapter
              key={item.slug}
              number={i + 1}
              title={item.title}
              description={item.description}
              imageUrl={item.imageUrl}
              slug={item.slug}
            />
          ))}
        </Chapters>
      </Grid.Cell>
      {/* <Grid.Cell span={{ small: 'full', medium: 'full', large: 3 }}>dfdsfds</Grid.Cell> */}
    </Grid>
  </PageSection>
)

export default Contents
